import React, { useCallback, useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import Swal from "sweetalert2";
import FullScreenLoader from '../Components/FullScreenLoader'



const Admin = () => {
const [uploading, setUploading] = useState(false)
const BASE_URl = window.location.origin
  const getHeaderImages = useCallback(()=>{
    fetch(`${BASE_URl}/api/showHeaderImages`, {
      method: 'GET',
      credentials: 'include'
  }).then((res) => res.json())
  .then((data) => {setHeaderVideos(data.images)})
  .catch((error) => console.log(error))
  },[BASE_URl])

  const handleVideoUpload = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("video", e.target.file.files[0]); // Change 'image' to 'video'
  
    setUploading(true)
    fetch(`${BASE_URl}/api/uploadVideo`, {  // Change API endpoint for videos
      method: 'POST',
      credentials: 'include',
      body: formData
    })
    .then((res) => res.json())
    .then((data) => {
      if (data && data.success === true) {
        setUploading(false)
        getHeaderImages(); // Fetch updated videos
        toast.success(data.message);
      } else if (data && data.success === false) {
        setUploading(false)
        toast.error(data.message);
      }
    })
    .catch((error) => {
      setUploading(false)
      toast.error(error.message || 'Something Went Wrong');
    });
  
    e.target.reset();
  };
  

  const [headerVideo, setHeaderVideos] = useState(null)



  useEffect(()=>{
    getHeaderImages()
  },[getHeaderImages])

const handleDeleteHeaderImage = async(id) => {
  const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      });

      if(result.isConfirmed){
        setUploading(true)
        fetch(`${BASE_URl}/api/deleteHeaderImage/${id}`, {
          method: 'DELETE',
          credentials: 'include'
        }).then((res) => res.json())
        .then((data) => {
          if(data && data.sucess === true) {
            setUploading(false)
            toast.success(data.messege)
            getHeaderImages()
          } else if(data && data.sucess === false){
            setUploading(false)
            toast.error(data.messege)
          }
        }).catch((error) => {
          setUploading(false)
          if(error) {
            toast.error(error.messege || 'Something Went Wrong')
          }
        })
      }
  
}
  return (
    <div className='mt-14 h-fit pb-6'>
      <div className='flex justify-center' style={{marginTop: '100px'}}>
    <form onSubmit={handleVideoUpload} className='bg-blue-400 w-[90%] flex flex-col items-center p-1.5 gap-5 rounded-2xl sm:w-[70%] xl:w-[60%]'>
      <label htmlFor="image" className='font-bold text-2xl font-sans'>Header Video</label>
      <input type="file" name="file" required className='border-[0.5px] w-[90%] p-2.5 rounded-2xl sm:w-[60%] xl:w-[50%]'/>
      <button type='submit' className='cursor-pointer border-[0.5px] p-3 rounded-2xl bg-blue-200 hover:bg-blue-300 ' style={{transition: '0.5s'}}>Upload</button>
    </form>
    {uploading?<FullScreenLoader/>:null}
    </div>
    <h1 className='text-center text-2xl font-bold mt-14'>Header Video</h1>
    <ul className='flex flex-row items-center justify-evenly gap-6 flex-wrap mt-5'>
    {headerVideo && headerVideo.length?<>
    {headerVideo.map((image, i) => {
      return(
        <li key={i} className='border-[0.5px] h-40 flex flex-col items-center gap-2 rounded-2xl'>
          <div className='h-24 w-44'>
            <img src={image.image.secure_url} alt={image._id} className='object-cover rounded-2xl'/>
          </div>
          <button className='bg-red-400 cursor-pointer hover:bg-red-500 p-2 rounded-[8px]'
          onClick={()=>{handleDeleteHeaderImage(image._id)}}
          >Delete</button>
        </li>
      )
    })}
    </>:<h1>No Viedo Avaible</h1>}
    </ul>
    </div>
  )
}

export default Admin
